import React from "react";
import { Link } from "react-router-dom";

function EntryCard({
  title,
  description,
  accent,
  to,
}: {
  title: string;
  description: string;
  accent: string;
  to: string;
}) {
  return (
    <Link
      to={to}
      className="block rounded-[2rem] border border-[#EADBC8] bg-white/90 p-6 shadow-[0_14px_34px_rgba(124,90,78,0.12)] transition hover:-translate-y-0.5 hover:bg-white"
    >
      <span className={`inline-flex rounded-full px-3 py-1 text-[11px] font-black ${accent}`}>すぐ使える</span>
      <h2 className="mt-4 text-xl font-black tracking-tight text-[#5D4D46]">{title}</h2>
      <p className="mt-2 text-sm leading-6 text-[#6B5851]">{description}</p>
      <p className="mt-5 text-sm font-black text-[#A67C52]">進む →</p>
    </Link>
  );
}

export default function TalkEntry() {
  return (
    <main className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(250,233,220,0.95),_rgba(255,249,245,1)_55%)] px-4 py-6 text-[#4A3E39] sm:px-6 sm:py-10">
      <div className="mx-auto w-full max-w-md">
        <header className="mb-6 flex items-center justify-between">
          <Link to="/home" className="text-sm font-bold text-[#A67C52] hover:text-[#7C5A4E]">
            ← 戻る
          </Link>
          <p className="text-sm font-bold tracking-tight text-[#7C5A4E]">メイと話す</p>
          <span className="text-xs text-[#9C867D]">WizMate</span>
        </header>

        <section className="rounded-[2.4rem] border border-white/80 bg-white/85 p-6 shadow-[0_24px_60px_rgba(124,90,78,0.16)] backdrop-blur-sm sm:p-7">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.18em] text-[#A67C52]">Talk Modes</p>
            <h1 className="mt-3 text-3xl font-black tracking-tight text-[#7C5A4E]">会話のしかたを選ぶ</h1>
          </div>

          <div className="mt-8 space-y-4">
            <EntryCard
              title="いつもの会話"
              description="メイと 1 対 1 で、いつもの会話をはじめます。気軽な相談や雑談の入口です。"
              accent="bg-[#5D4D46] text-white"
              to="/chat"
            />
            <EntryCard
              title="みんなで話す"
              description="複数の役割や視点を交えて、壁打ちや相談を進めます。経営会議やプロジェクト会議の土台になるモードです。"
              accent="bg-[#FFF3E9] text-[#A46D4C]"
              to="/talk/group"
            />
          </div>
        </section>
      </div>
    </main>
  );
}
